import React from "react";
import { Minus, Plus } from "lucide-react";
import { useCart } from "../../pages/ShopCart";
import { useI18n } from "../../lib/i18n";

const CHILI = "#E54D2E";

// Ajout direct depuis la carte du catalogue (sans ouvrir la fiche du plat).
export function CatalogQtyControl({ product }) {
  const { items, add, setQty, remove } = useCart();
  const { t } = useI18n();
  if (product.price_online == null) return null;
  if (product.sold_out) {
    return (
      <div
        className="mt-2 w-full py-2.5 text-center text-[11px] sm:text-xs uppercase tracking-[0.18em] font-semibold border"
        style={{ borderColor: "rgba(242,236,228,0.2)", color: "#A6A29C" }}
        onClick={(e) => e.stopPropagation()}
        data-testid={`quick-sold-out-${product.id}`}
      >
        {t("add_to_cart.sold_out")}
      </div>
    );
  }
  const line = items.find((it) => it.product_id === product.id);
  const stop = (fn) => (e) => { e.stopPropagation(); fn(); };

  if (!line) {
    return (
      <button
        onClick={stop(() => add(product, 1))}
        className="mt-2 w-full py-2.5 flex items-center justify-center gap-1.5 text-[11px] sm:text-xs uppercase tracking-[0.18em] font-semibold transition-transform active:scale-[0.97]"
        style={{ background: CHILI, color: "#FFFFFF" }}
        data-testid={`quick-add-${product.id}`}
      >
        <Plus className="w-3.5 h-3.5" /> {t("add_to_cart.quick")}
      </button>
    );
  }
  return (
    <div
      className="mt-2 flex items-center justify-between border"
      style={{ borderColor: CHILI }}
      onClick={(e) => e.stopPropagation()}
      data-testid={`quick-qty-${product.id}`}
    >
      <button
        onClick={stop(() => (line.quantity <= 1 ? remove(product.id) : setQty(product.id, line.quantity - 1)))}
        className="w-11 h-10 flex items-center justify-center active:bg-white/10"
        aria-label={t("add_to_cart.remove_one")}
        data-testid={`quick-minus-${product.id}`}
      >
        <Minus className="w-4 h-4" />
      </button>
      <span className="font-mono text-sm" data-testid={`quick-qty-value-${product.id}`}>{line.quantity}</span>
      <button
        onClick={stop(() => setQty(product.id, line.quantity + 1))}
        className="w-11 h-10 flex items-center justify-center active:bg-white/10"
        style={{ background: CHILI, color: "#FFFFFF" }}
        aria-label={t("add_to_cart.add_one")}
        data-testid={`quick-plus-${product.id}`}
      >
        <Plus className="w-4 h-4" />
      </button>
    </div>
  );
}
